import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../components/Utils/Custom/HelperCode";
import { LayoutReducerModel } from "../../components/Utils/Models/store";

// interface LayoutReducerModel {
//   isOpenSideBar: boolean
//   prefersDarkMode: boolean
// }
const initialState: LayoutReducerModel = {
  isOpenSideBar: true,
  prefersDarkMode: true,
};

//////////////Reducer Slice//////////////////////
const changeSideBar_Reducer = (state: LayoutReducerModel, action: any) => {
  return updateObject(state, { isOpenSideBar: action.value });
};
const changeTheme_Reducer = (state: LayoutReducerModel, action: any) => {
  return updateObject(state, { prefersDarkMode: !state.prefersDarkMode });
};

/////REDUCER//////
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SIDEBARNAV_POSITION:
      return changeSideBar_Reducer(state, action);
    case actionTypes.CHANGE_THEME:
      return changeTheme_Reducer(state, action);
    default:
      return state;
  }
};
export default reducer;
